import { Action } from '@ngrx/store';

export enum LoadingFlowActionTypes {
  ToggleState = '[loadingFlow] Toggle Loading Flow',
}

export class ToggleState implements Action {
  readonly type = LoadingFlowActionTypes.ToggleState;
  constructor(private payload: { url: string; state: boolean }) {}
}
